import {
  Tooltip,
  TooltipProps
} from "@fluentui/react-components";


interface TooltipCustomProps {
  rcName?: string;
  theme?: string;
}

const TooltipCustom = (props: TooltipCustomProps & TooltipProps) => {
  return (
    <Tooltip {...props} />
  );
};

export default TooltipCustom;
